export default function formSelection({main, on, elm, state}) {
    const filtersCount = elm.querySelectorAll('[data-filter]').length;
    const submitBtn = elm.querySelector('.form__submit');
    let filterState = '';

    main(_ => {
        on('change', '[data-filter]', changeFilters)
        on('click', '.form__submit', findMat);
    });

    const changeFilters = async function (e) {
        const {category_id, language_id} = state.get();
        const nextFilter = e.target.closest('select-choices').nextElementSibling;

        clearNextFilters(nextFilter);

        const filters = getSelectedFilters();
        // updateSubmitState(filters);

        if (!nextFilter || checkState(filters)) return;

        nextFilter.choices.enable();

        const result = await sendRequest({
            route: `extension/evasota/module/product_selection_form.getFilterValues`,
            filter_group_id: nextFilter.dataset.filter,
            category_id,
            language_id,
            ...filters
        });

        nextFilter.choices.setChoices(result.values, 'filter_id', 'name', true, true, true);
    };

    const findMat = async function() {
        const {category_id, language_id} = state.get();
        const filters = getSelectedFilters();

        const result = await sendRequest({
            route: `extension/evasota/module/product_selection_form.findProduct`,
            category_id,
            language_id,
            ...filters
        });

        if (result.url) {
            location.href = result.url;
        }
    };

    const clearNextFilters = function(startEl) {
        let el = startEl;

        while (el) {
            el.choices.clearChoices(true, true);
            el.choices.disable();
            el = el.nextElementSibling;
        }
    };

    const getSelectedFilters = function() {
        const selectedFilters = elm.querySelectorAll('[data-filter] option[selected]:not([value=""])');

        return [...selectedFilters].reduce((acc, el) => {
            const group = el.closest('select-choices').dataset.filter;
            acc[`filters[${group}]`] = el.value;
            return acc;
        }, {});
    };

    const updateSubmitState = function(filters) {
        submitBtn.toggleAttribute('disabled', Object.keys(filters).length !== filtersCount);
    };

    const checkState = function(filters) {
        const newFilterState = JSON.stringify(filters);
        if (newFilterState === filterState) return true;

        filterState = newFilterState;
        return false;
    };

    const sendRequest = async function(params) {
        const query = new URLSearchParams(params);
        setLoading(true);

        try {
            const response = await fetch(`index.php?${query}`);

            if (!response.ok) throw new Error(`Response status: ${response.status}`);

            return await response.json();
        } catch (e) {
            alert(`Error: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };

    const setLoading = function(isLoading) {
        let loader = elm.querySelector('.lmask');

        if (isLoading) {
            if (loader) return;

            loader = document.createElement('div');
            loader.classList.add('lmask');
            elm.insertAdjacentElement('afterbegin', loader);
            return;
        }

        loader?.remove();
    };
};

export const model = {};
